import { render, staticRenderFns } from "./UseGuide.vue?vue&type=template&id=37862971&scoped=true"
import script from "./UseGuide.vue?vue&type=script&lang=js"
export * from "./UseGuide.vue?vue&type=script&lang=js"
import style0 from "./UseGuide.vue?vue&type=style&index=0&id=37862971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37862971",
  null
  
)

export default component.exports